class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) {
      facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      
      if (searchParams === FacetFiltersForm.searchParamsPrev) {
        return;
      }

      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static async getReviewInfo(card, handle) {
    if (handle == undefined || handle == null) {
      return;
    }

    const shopifyProductUrl = `/products/${handle}?section_id=product-extras-reviews`;

    try {
      const response = await fetch(shopifyProductUrl);
      const res = await response.text();

      let p = new DOMParser();
      let doc = p.parseFromString(res, "text/html");
      let template = doc.querySelector(".tp-stars-rating");

      if (template) {
        card.appendChild(template);
      }
    } catch (error) {
      console.error("Error fetching review:", error);
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) {
      FacetFiltersForm.updateURLHash(searchParams);
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    container.innerHTML = innerHTML;

    const cards = container.querySelectorAll('.card-product-slim');
    cards.forEach((card) => {
      const handle = card.getAttribute('data-handle');
      FacetFiltersForm.getReviewInfo(card, handle);
    });
  }

  static renderProductCount(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const countElement = parsedHTML.getElementById('ProductCount');
    
    if (!countElement) {
      return;
    }

    const count = countElement.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    container.innerHTML = count;
    container.classList.remove('loading');
    
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);

      if (target) {
        const trigger = target.querySelector('.mobile-refine-trigger');
        const content = target.querySelector('.refine-mobile');
        const showMoreBtn = target.querySelector('.ais-RefinementList-showMore');

        const isTriggerActive = trigger && trigger.classList.contains('active');
        const isContentShow = content && content.classList.contains('show');
        const isListExpanded = showMoreBtn && showMoreBtn.querySelector('.text-show-more').classList.contains('hidden');

        target.innerHTML = element.innerHTML;

        if (isTriggerActive) target.querySelector('.mobile-refine-trigger')?.classList.add('active');
        if (isContentShow) target.querySelector('.refine-mobile')?.classList.add('show');
        
        if (isListExpanded) {
          const newShowMoreBtn = target.querySelector('.ais-RefinementList-showMore');

          if (newShowMoreBtn) {
            target.querySelectorAll('.mobile-show-more-item').forEach(item => item.classList.remove('hidden'));
            newShowMoreBtn.querySelector('.text-show-more').classList.add('hidden');
            newShowMoreBtn.querySelector('.text-show-less').classList.remove('hidden');
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);

      if (!activeFacetsElement) {
        return;
      }
      
      const targets = document.querySelectorAll(selector);

      targets.forEach((target) => {
        target.innerHTML = activeFacetsElement.innerHTML;
      });
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      const source = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (source && target) {
        target.innerHTML = source.innerHTML;
      }
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      targetElement.outerHTML = sourceElement.outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      targetElementAccessibility.outerHTML = sourceElementAccessibility.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    const grid = document.getElementById('product-grid');
    return [
      {
        section: grid ? grid.dataset.id : '',
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.target.classList.contains('mobile-facets__checkbox')) {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

if (!customElements.get('load-more')) {
  customElements.define('load-more', class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.btn = this.querySelector('.load-more-btn');
      this.spinner = this.querySelector('.loading-overlay__spinner');
      this.text = this.querySelector('.load-more-text');
      this.currentCountEl = this.querySelector('.load-more-current');
      this.isLoading = false;

      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }

      if (this.btn) {
        this.btn.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadNextPage();
        });
      }
    }

    connectedCallback() {
      const isRestored = this.restoreState();
      
      if (!isRestored) {
        this.checkInitialPage();
      }

      this.setupProductClickTracking();
      this.updateCount();
    }

    get cacheKey() {
      return window.location.pathname + window.location.search;
    }

    updateCount() {
      const grid = document.getElementById('product-grid');

      if (grid && this.currentCountEl) {
        const currentItems = grid.children.length;

        this.currentCountEl.textContent = currentItems;
      }
    }

    setupProductClickTracking() {
      if (window.loadMoreTrackingSetup) {
        return;
      }

      window.loadMoreTrackingSetup = true;

      const saveState = () => {
        const grid = document.getElementById('product-grid');
        const loadMoreEl = document.querySelector('load-more');

        if (grid) {
          sessionStorage.setItem('scroll_pos_' + this.cacheKey, window.scrollY);
          sessionStorage.setItem('saved_grid_' + this.cacheKey, grid.innerHTML);

          if (loadMoreEl) {
            const nextUrl = loadMoreEl.getAttribute('data-next-url') || '';

            sessionStorage.setItem('saved_next_url_' + this.cacheKey, nextUrl);
          }
        }
      };
      
      document.addEventListener('click', (e) => {
        const link = e.target.closest('#product-grid a');

        if (link && link.href.includes('/products/')) {
          saveState();
        }
      });

      window.addEventListener('beforeunload', () => {
        saveState();
      });
    }

    restoreState() {
      const savedGrid = sessionStorage.getItem('saved_grid_' + this.cacheKey);
      const savedScroll = sessionStorage.getItem('scroll_pos_' + this.cacheKey);
      const savedNextUrl = sessionStorage.getItem('saved_next_url_' + this.cacheKey);

      if (savedGrid) {
        const grid = document.getElementById('product-grid');

        if (grid) {
          grid.innerHTML = savedGrid;
        }

        if (savedNextUrl && savedNextUrl !== 'null') {
          this.setAttribute('data-next-url', savedNextUrl);
        } else {
          this.style.display = 'none';
        }

        if (savedScroll) {
          setTimeout(() => {
            window.scrollTo({
              top: parseInt(savedScroll, 10),
              behavior: 'instant'
            });
          }, 100);
        }

        sessionStorage.removeItem('saved_grid_' + this.cacheKey);
        sessionStorage.removeItem('scroll_pos_' + this.cacheKey);
        sessionStorage.removeItem('saved_next_url_' + this.cacheKey);

        return true;
      }

      return false;
    }

    async checkInitialPage() {
      const currentUrl = new URL(window.location.href);
      const initialPage = parseInt(currentUrl.searchParams.get('page'), 10);

      if (initialPage && initialPage > 1) {
        this.isLoading = true;
        this.text.classList.add('hidden');
        this.spinner.classList.remove('hidden');

        const sectionId = this.getAttribute('data-section-id');
        const urlWithoutPage = new URL(window.location.href);
        urlWithoutPage.searchParams.delete('page');

        const baseUrl = urlWithoutPage.toString();
        const separator = baseUrl.includes('?') ? '&' : '?';
        const fetchPromises = [];

        for (let p = 1; p < initialPage; p++) {
          const fetchUrl = `${baseUrl}${separator}page=${p}&section_id=${sectionId}`;

          fetchPromises.push(fetch(fetchUrl).then(res => res.text()));
        }

        try {
          const pagesHtml = await Promise.all(fetchPromises);
          const grid = document.getElementById('product-grid');
          const originalFirstChild = grid.firstElementChild;
          const fragment = document.createDocumentFragment();

          pagesHtml.forEach((htmlString) => {
            const html = new DOMParser().parseFromString(htmlString, 'text/html');
            const newProducts = html.querySelectorAll('#product-grid > li');

            newProducts.forEach((li) => {
              fragment.appendChild(li);

              const card = li.querySelector('.card-product-slim');

              if (card) {
                const handle = card.getAttribute('data-handle');

                if (typeof FacetFiltersForm !== 'undefined') {
                  FacetFiltersForm.getReviewInfo(card, handle);
                }
              }
            });
          });

          if (fragment.children.length > 0) {
            grid.insertBefore(fragment, originalFirstChild);
          }

          this.updateCount();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
          this.spinner.classList.add('hidden');
          this.text.classList.remove('hidden');

          const grid = document.getElementById('product-grid');
          const targetChild = grid.firstElementChild;

          if (targetChild) {
            setTimeout(() => {
              targetChild.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
              });
            }, 100);
          }
        }
      }
    }

    async loadNextPage() {
      const url = this.getAttribute('data-next-url');
      const sectionId = this.getAttribute('data-section-id');

      if (!url || this.isLoading) {
        return;
      }

      const fetchUrlObj = new URL(url, window.location.origin);
      const pageToSet = fetchUrlObj.searchParams.get('page');

      if (pageToSet) {
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('page', pageToSet);

        history.replaceState(null, null, newUrl.toString());
      }

      this.isLoading = true;
      this.text.classList.add('hidden');
      this.spinner.classList.remove('hidden');

      try {
        const response = await fetch(`${url}&section_id=${sectionId}`);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const newProducts = html.querySelectorAll('#product-grid > li');
        const nextTrigger = html.querySelector('load-more');
        const productGrid = document.getElementById('product-grid');

        if (productGrid && newProducts.length > 0) {
          newProducts.forEach((li) => {
            productGrid.appendChild(li);
            
            const card = li.querySelector('.card-product-slim');

            if (card) {
              const handle = card.getAttribute('data-handle');

              if (typeof FacetFiltersForm !== 'undefined') {
                FacetFiltersForm.getReviewInfo(card, handle);
              }
            }
          });
        }

        this.updateCount();

        if (nextTrigger) {
          const nextUrl = nextTrigger.getAttribute('data-next-url');

          this.setAttribute('data-next-url', nextUrl);

          if (this.btn) {
            this.btn.setAttribute('href', nextUrl);
          }
        } else {
          this.removeAttribute('data-next-url');
          this.style.display = 'none';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
        this.spinner.classList.add('hidden');
        this.text.classList.remove('hidden');
      }
    }
  });
}